import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/c")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
